/**
 * 获取评论列表
 * @param area_id 评论区ID
 * @param page 分页
 * @param order 排序
 * @returns 评论列表
 */
export async function fetchCommentList(
  area_id: number,
  page: number,
  order: 'desc' | 'asc'
): Promise<CommentDetail[]> {
  return http
    .get<CommentDetail[]>('/v1/comment/list', {
      area_id,
      page,
      order,
      html: 1
    })
    .then((res) => {
      // undefined is not an object (evaluating 'm.data')
      // on ios 13.3 with safari
      // no idea why this happens
      return res?.data || []
    })
    .catch(() => {
      return []
    })
}
